export default __webpack_public_path__ + "static/media/mint-banner.2b61c934.png";